(function(){
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(min-width: 992px)') : null;
  function setImp(el, prop, val){ if(el && el.style) el.style.setProperty(prop, val, 'important'); }
  function align(){
    if(mq && !mq.matches) return;
    document.querySelectorAll('#offcanvas-cart .offcanvas-header button.btn-close, #offcanvas-cart button.btn-close.l4v-cart-drawer-close').forEach(function(btn){
      setImp(btn, 'top', '66px');
      setImp(btn, 'right', '30px');
      ['width','height','min-width','min-height','max-width','max-height'].forEach(function(p){ setImp(btn, p, '22px'); });
      setImp(btn, 'background-size', '10px 10px');
      setImp(btn, 'background-position', 'center center');
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', align, {once:true});
  else align();
  window.addEventListener('load', align, {once:true, passive:true});
  document.addEventListener('shown.bs.offcanvas', function(e){ if(e.target && e.target.id === 'offcanvas-cart') align(); });
})();
